const summerRegistrationPage = document.querySelector('.summer-promo--registration');

if (summerRegistrationPage) {
  const subheading = summerRegistrationPage.querySelector('.lbk-rich-text-component p');
  const heading = summerRegistrationPage.querySelector('.lbk-rich-text-component h1');
  const form = summerRegistrationPage.querySelector('.webform-submission-form');

  //load svg for now until we have lotie anim
  const lotieAnimationDj = document.getElementById('lottie-animation-dj');
  const inlineSVG = `
    <svg width="1278" height="798" viewBox="0 0 1278 798" fill="none"
     xmlns="http://www.w3.org/2000/svg">
      <g id='icon' clip-path="url(#clip0_156_1259)">
        <path
          d="M238.258 165.869C238.258 165.869 180.002 206.927 180.002 304.879C180.002 443.982 264.981 524.324 264.981 524.324C264.981 524.324 87.7351 433.799 87.7351 276.245C87.7351 135.6 238.305 165.869 238.305 165.869H238.258Z"
          fill="#049421"/>
        <path
          d="M988.866 405.633C988.866 405.633 1033.06 395.73 1084.45 395.73C1175.55 395.73 1213.02 448.513 1213.02 522.922C1213.02 597.332 1163.68 654.552 1163.68 654.552C1163.68 654.552 1278.05 585.561 1278.05 458.882C1278.05 374.57 1220.44 332.718 1140.7 332.718C1037.27 332.718 988.913 405.586 988.913 405.586L988.866 405.633Z"
          fill="#049421"/>
        <path
          d="M8.41692e-05 424.831C8.41692e-05 424.831 56.9953 474.391 150.15 501.856C150.15 501.856 121.886 511.012 73.8135 509.47C73.8135 509.47 127.118 568.092 127.118 600.415C127.118 632.739 110.954 643.482 81.8489 643.482C52.744 643.482 11.259 617.605 11.259 577.761C11.259 542.261 58.6771 556.834 58.6771 556.834C58.6771 556.834 -1.77518 475.231 -0.0466332 424.784L8.41692e-05 424.831Z"
          fill="#002F87"/>
        <path
          d="M970.039 163.159C970.039 163.159 954.716 211.271 957.893 281.85C957.893 281.85 966.115 275.498 985.876 275.498C1009.47 275.498 1016.9 297.872 1016.9 315.669C1016.9 333.465 1000.73 361.585 969.292 361.585C937.851 361.585 915.52 337.716 915.52 287.315C915.52 253.123 919.211 237.055 919.211 237.055C919.211 237.055 896.132 249.246 866.7 281.009C866.7 281.009 869.83 190.018 970.039 163.159Z"
          fill="#002F87"/>
        <path
          d="M418.541 702.337C453.579 702.337 481.983 694.327 481.983 684.447C481.983 674.566 453.579 666.557 418.541 666.557C383.503 666.557 355.099 674.566 355.099 684.447C355.099 694.327 383.503 702.337 418.541 702.337Z"
          fill="#002F87"/>
        <path
          d="M988.866 557.348C988.866 557.348 795.456 618.165 543.416 618.165C370.936 618.165 301.14 557.348 301.14 557.348C112.682 663.007 61.1531 797.999 61.1531 797.999C459.419 759.09 1247.07 771.001 1247.07 771.001C1108.46 677.674 988.82 557.348 988.82 557.348H988.866ZM415.177 742.274C318.846 742.274 240.781 720.227 240.781 693.088C240.781 665.949 318.846 643.902 415.177 643.902C511.508 643.902 589.573 665.949 589.573 693.088C589.573 720.227 511.508 742.274 415.177 742.274ZM851.471 738.117C741.124 738.117 651.707 714.061 651.707 684.4C651.707 654.739 741.124 630.683 851.471 630.683C961.817 630.683 1051.23 654.739 1051.23 684.4C1051.23 714.061 961.817 738.117 851.471 738.117Z"
          fill="#002F87"/>
        <path
          d="M856.656 691.921C903.666 691.921 941.775 681.171 941.775 667.911C941.775 654.652 903.666 643.902 856.656 643.902C809.646 643.902 771.537 654.652 771.537 667.911C771.537 681.171 809.646 691.921 856.656 691.921Z"
          fill="#002F87"/>
        <path
          d="M772.705 195.436C772.705 195.436 481.983 242.053 481.983 382.558C481.983 461.405 539.912 513.207 675.346 513.207C795.643 513.207 923.836 445.103 1027.97 445.103C1132.1 445.103 1159.01 485.367 1159.01 541.934C1159.01 621.949 1038.43 684.4 1023.34 729.616C1023.34 729.616 977.888 704.953 990.408 658.196C990.408 658.196 949.016 695.658 881.463 696.405C881.463 696.405 874.969 665.576 908.325 632.645C908.325 632.645 829.373 666.51 784.431 623.537C784.431 623.537 934.441 576.313 934.441 537.076C934.441 526.706 927.807 520.167 908.092 520.167C856.236 520.167 750.374 582.899 584.154 582.899C382.802 582.899 242.93 492.094 242.93 326.365C242.837 129.154 516.32 50.7742 570.606 0C570.606 0 583.92 46.1031 562.617 85.9471C562.617 85.9471 641.056 56.2393 702.676 62.0314C702.676 62.0314 686.698 112.992 641.943 146.671C641.943 146.671 738.134 144.475 772.705 195.436Z"
          fill="#049421"/>
        <path
          d="M573.175 441.88C573.175 441.88 574.951 289.417 702.676 289.417C737.994 289.417 750.094 293.201 773.219 293.201C810.406 293.201 832.363 270.64 832.363 270.64C832.363 270.64 841.006 296.797 841.006 324.03C841.006 419.319 783.03 480.883 686.044 480.883C608.12 480.883 573.175 441.833 573.175 441.833V441.88Z"
          fill="#049421"/>
        <path
          d="M610.316 377.513C610.316 377.513 699.779 326.412 853.059 326.412C853.059 326.412 850.583 347.665 843.856 377.233L773.313 389.658L754.672 352.29L741.264 355.466L733.463 400.822L655.118 425.158C655.118 425.158 632.133 409.603 610.362 377.513H610.316Z"
          fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_156_1259">
          <rect width="1278" height="798" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;

  window.addEventListener('load', () => {
    if (summerRegistrationPage) {

      if (lotieAnimationDj) {
        lotieAnimationDj.innerHTML = inlineSVG;
      }

      if (heading) {
        setTimeout(() => {
          heading.classList.add('reveal-bottom-to-top');
        }, 500);
      }

      if (subheading) {
        setTimeout(() => {
          subheading.classList.add('reveal-bottom-to-top');
        }, 600);
      }

      if (form) {
        setTimeout(() => {
          form.classList.add('animate');
        }, 600);
      }


      // ==== START of file required validation workaround ====
      const fileInput = form.querySelector('input[type="file"][name="files[image]"]');
      const descriptionDiv = form.querySelector('#edit-image--description');

      if (fileInput && descriptionDiv) {
        const errorMsg = descriptionDiv.querySelector('.error-msg');

        form.addEventListener('submit', (e) => {
          if (!fileInput.value) {
            e.preventDefault();
            if (errorMsg) errorMsg.style.display = 'block';
            fileInput.focus();
          } else {
            if (errorMsg) errorMsg.style.display = 'none';
          }
        });

        fileInput.addEventListener('change', () => {
          if (fileInput.value && errorMsg) {
            errorMsg.style.display = 'none';
          }
        });
      }
      // ==== END of file required validation workaround ====

    }
  });
}

// Fix for chrome/edge issues for showing error message on required inputs because of the viewport

if (document.body.classList.contains('node--summer_promo') && document.body.querySelector('.webform-submission-form')) {
  document.documentElement.style.scrollBehavior = 'auto';
  document.body.style.scrollBehavior = 'auto';
}

// Add close btn if the registration page contains error-messages div

// document.addEventListener("DOMContentLoaded", function() {
//   const registrationPage = document.querySelector('.summer-promo--registration');
//   const errorMessagesContainer = document.querySelector('div[role="contentinfo"][aria-label="Error message"]')

//   if(registrationPage && errorMessagesContainer) {
//     const closeSpan = document.createElement('span')

//     closeSpan.classList.add('close')

//     closeSpan.innerHTML = '&#x2715;';

//     errorMessagesContainer.appendChild(closeSpan);

//     closeSpan.addEventListener('click', function() {
//       errorMessagesContainer.classList.add('hidden'); 
//     });
//   }
// });